import React from "react";

import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";

import { CHAR_LIMITS } from "../SubmissionForm/Constant";
import "./Comment.css";

export default function Comment({
  commentRef,
  defaultValue,
  placeholder,
  showButtons,
  handleCancelClick,
  handleSubmitClick,
  loading,
  textareaClassName,
  variant,
}) {
  let baseTextAreaClass;
  if (showButtons) {
    baseTextAreaClass = "SubmissionFrom__Comment";
  } else if (typeof textareaClassName === "string" && textareaClassName.includes("confirmModalBox")) {
    baseTextAreaClass = undefined;
  } else {
    baseTextAreaClass = "SubmissionFrom__Comment_Add";
  }
  const textAreaClassNames = [baseTextAreaClass, textareaClassName].filter(Boolean).join(" ");

  return (
    <div className="SubmissionFrom__CommentContainer">
      <div className="SubmissionFrom__CommentButtonTitle">
        {showButtons ? <span className="SubmissionForm_Comment--title">Comments:</span> : ""}
        {showButtons && (
        <div className="SubmissionFrom__Comment__Buttons">
          <Button
            type="text"
            shape="circle"
            onClick={handleSubmitClick}
            loading={loading}
            disabled={loading}
            className="SubmissionFrom__Comment__Button"
            icon={<CheckCircleOutlined />}
          />
          <Button
            type="text"
            shape="circle"
            onClick={handleCancelClick}
            disabled={loading}
            className="SubmissionFrom__Comment__Button"
            icon={<CloseCircleOutlined />}
          />
        </div>
        )}
      </div>
      <Input.TextArea
        ref={commentRef}
        id="submission-comment"
        rows={4}
        maxLength={CHAR_LIMITS.comment}
        className={textAreaClassNames}
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={loading}
        variant={variant}
        style={{ resize: "none" }}
      />
    </div>
  );
}
